var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIotinboxFavicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.6,
    cy: 1.65309,
    rx: 1.6,
    ry: 1.65309,
    fill: "#5C85FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.7333,
    cy: 1.9286,
    rx: 1.86667,
    ry: 1.9286,
    fill: "#5C85FF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.1333,
    cy: 1.9286,
    rx: 1.86667,
    ry: 1.9286,
    fill: "#5C85FF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.86667,
    cy: 7.97547,
    rx: 1.86667,
    ry: 1.9286,
    fill: "#5C85FF"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.7333,
    cy: 7.97547,
    rx: 1.86667,
    ry: 1.9286,
    fill: "#5C85FF"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.8667,
    cy: 7.74708,
    rx: 2.13333,
    ry: 2.20411,
    fill: "#5C85FF"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.86667,
    cy: 14.0224,
    rx: 1.86667,
    ry: 1.9286,
    fill: "#5C85FF"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.99997,
    cy: 13.7979,
    rx: 2.13333,
    ry: 2.20411,
    fill: "#5C85FF"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.8667,
    cy: 13.7979,
    rx: 2.13333,
    ry: 2.20411,
    fill: "#5C85FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotinboxFavicon);
export default __webpack_public_path__ + "static/media/iotinbox_favicon.438c4fe08e603d001de15f52f6d4b7d6.svg";
export { ForwardRef as ReactComponent };